// src/services/exitRoomService.ts
import SocketService from '@src/services/SocketService';
import { cleanProducers } from './producerService';
import { audioProcessor } from './AudioProcessorService';
import { EMeetingRoutes } from '@src/constants';
import type { Transport } from 'mediasoup-client/lib/Transport';
import { NavigateFunction } from 'react-router-dom';

export interface ExitRoomOptions {
  offline?: boolean;
  closeForEveryone?: boolean;
  isBanned?: boolean;
  consumerTransport?: Transport | null;
  navigate?: NavigateFunction;
}

/**
 * Handles SFU / socket exit logic and cleanup.
 * Returns which route the caller should navigate to.
 */
export const exitRoomService = ({
  offline = false,
  closeForEveryone = false,
  isBanned = false,
  consumerTransport,
  navigate,
}: ExitRoomOptions) => {
  if (!offline) {
    const payload = closeForEveryone ? { closeRoom: true } : undefined;
    SocketService.emit('exitRoom', payload);
  }

  // Centralized media/socket cleanup
  cleanProducers(consumerTransport);

  // Full audio processor teardown (closes AudioContext)
  audioProcessor.dispose();

  let path: EMeetingRoutes;
  if (isBanned) {
    path = EMeetingRoutes.RESTRICTED_ACCESS;
  } else if (closeForEveryone) {
    path = EMeetingRoutes.END;
  } else {
    path = EMeetingRoutes.REJOIN;
  }

  if (navigate) {
    navigate(path);
  }
};
